<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Requisition Approval" subTitle="Forms" />

    <ListApprovalRequisition />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import ListApprovalRequisition from "@/components/Pages/Management/Requisition/ApprovalRequisition.vue";

export default defineComponent({
  name: "ListApprovalRequisitionPage",
  components: {
    PageTitle,
    ListApprovalRequisition,
  },
});
</script>
